// src/game/Inventory.js

class Inventory {
  static instance = null;

  idToVoxel = {
    1: 'grass',
    2: 'dirt',
    3: 'stone',
    4: 'coal_ore',
    5: 'iron_ore',
    6: 'tree_top',
    7: 'leave',
    8: 'sand',
    9: 'cloud',
    10: 'snow',
    11: 'jungle_tree',
    12: 'jungle_leaves',
    13: 'cactus',
    14: 'jungle_grass',
    15: 'lava',
    16: 'frost_mint'
  };

  rarity = ["common", "uncommon", "rare", "epic", "legendary"];

  constructor() {
    if (Inventory.instance) {
      return Inventory.instance;
    }

    const voxelTypes = Object.values(this.idToVoxel);

    const initRarityMap = () => Object.fromEntries(voxelTypes.map(name => [name, 0]));

    this._voxelInventory = {
      available: Object.fromEntries(this.rarity.map(r => [r, initRarityMap()])),
      used: Object.fromEntries(this.rarity.map(r => [r, initRarityMap()])),
      staked: Object.fromEntries(this.rarity.map(r => [r, initRarityMap()])),
    };

    Inventory.instance = this;
  }

  static getInstance() {
    if (!Inventory.instance) {
      Inventory.instance = new Inventory();
    }
    return Inventory.instance;
  }

  updateInventory(newInventory) {
    if (newInventory && newInventory.available && newInventory.used && newInventory.staked) {
      this._voxelInventory = newInventory;
    } else {
      console.error("Invalid inventory structure provided to updateInventory:", newInventory);
    }
  }

  getStakedVoxelCount(type, rarity) {
    return this.getVoxelCount(type, rarity, 'staked');
  }

  getInventory() {
    return this._voxelInventory;
  }

  getVoxelCount(type, rarity, section) {
    if (!this._voxelInventory || !this._voxelInventory[section] || !this._voxelInventory[section][rarity]) {
      console.warn(`getVoxelCount: Invalid inventory section (${section}), rarity (${rarity}), or inventory data.`);
      return 0;
    }
    return this._voxelInventory[section][rarity][type] || 0;
  }

  getVoxelCountById(id, section) {
    const voxelType = this.idToVoxel[id];
    if (!voxelType) {
      console.warn(`getVoxelCountById: No voxel type found for block ID ${id}.`);
      return 0;
    }

    if (!this._voxelInventory || !this._voxelInventory[section]) {
      console.warn(`getVoxelCountById: Invalid inventory section (${section}) or inventory data.`);
      return 0;
    }

    let totalCount = 0;
    const sectionInventory = this._voxelInventory[section];

    for (const rareType of this.rarity) {
      if (Object.prototype.hasOwnProperty.call(sectionInventory, rareType) &&
        sectionInventory[rareType] &&
        Object.prototype.hasOwnProperty.call(sectionInventory[rareType], voxelType)) {
        totalCount += sectionInventory[rareType][voxelType] || 0;
      }
    }
    return totalCount;
  }

  hasVoxel(type, rarity, count = 1) {
    return this.getVoxelCount(type, rarity, 'available') >= count;
  }

  getUsedVoxelCount(type, rarity) {
    return this.getVoxelCount(type, rarity, 'used');
  }

  getAvailableVoxelCount(type, rarity) {
    return this.getVoxelCount(type, rarity, 'available');
  }
}

export const InventorySingleton = Inventory.getInstance();
